import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/containers/accordion.containers';
import { YesNoRendererComponent } from '../../../../../common/components/yes-no-renderer.component';

export default function ProgramBasicInfoComponent({
  selectedProgram
}: any) {
  const program = selectedProgram?.ONEProgram;

  return (
    <AccordionContainer
      child={
        <div className="p-8 bg-gradient-to-br from-yellow-100 via-pink-50 to-orange-100 border border-amber-300 rounded-2xl shadow-xl text-gray-900">
          
          <h1 className="text-4xl font-extrabold text-center text-indigo-900 mb-6">
            {program?.Name || ''}
          </h1>
          
          <div className="grid md:grid-cols-2 gap-6 text-lg mb-6">
            <div className="space-y-2">
              <p className="flex items-center gap-2"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#0b1158" fill="none">
    <path d="M16 2V6M8 2V6" stroke="#0b1158" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
    <path d="M13 4H11C7.22876 4 5.34315 4 4.17157 5.17157C3 6.34315 3 8.22876 3 12V14C3 17.7712 3 19.6569 4.17157 20.8284C5.34315 22 7.22876 22 11 22H13C16.7712 22 18.6569 22 19.8284 20.8284C21 19.6569 21 17.7712 21 14V12C21 8.22876 21 6.34315 19.8284 5.17157C18.6569 4 16.7712 4 13 4Z" stroke="#0b1158" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
    <path d="M3 10H21" stroke="#0b1158" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
    <path d="M11.9955 14H12.0045M11.9955 18H12.0045M15.991 14H16M8 14H8.00897M8 18H8.00897" stroke="#0b1158" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
</svg> <strong>Start Date:</strong> {program?.StartDateUtc || '-'}</p>
              <p className="flex items-center gap-2"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#0b1158" fill="none">
    <path d="M16 2V6M8 2V6" stroke="#0b1158" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
    <path d="M13 4H11C7.22876 4 5.34315 4 4.17157 5.17157C3 6.34315 3 8.22876 3 12V14C3 17.7712 3 19.6569 4.17157 20.8284C5.34315 22 7.22876 22 11 22H13C16.7712 22 18.6569 22 19.8284 20.8284C21 19.6569 21 17.7712 21 14V12C21 8.22876 21 6.34315 19.8284 5.17157C18.6569 4 16.7712 4 13 4Z" stroke="#0b1158" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
    <path d="M3 10H21" stroke="#0b1158" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
    <path d="M11.9955 14H12.0045M11.9955 18H12.0045M15.991 14H16M8 14H8.00897M8 18H8.00897" stroke="#0b1158" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
</svg> <strong>End Date:</strong> {program?.EndDateUtc || '-'}</p>
              <p className="flex items-center gap-2"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#070925" fill="none">
    <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C7.52232 2 3.77426 4.94289 2.5 9H5" stroke="#070925" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
    <path d="M12 8V12L14 14" stroke="#070925" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
    <path d="M2 12C2 12.3373 2.0152 12.6709 2.04494 13M9 22C8.6584 21.8876 8.32471 21.7564 8 21.6078M3.20939 17C3.01655 16.6284 2.84453 16.2433 2.69497 15.8462M4.83122 19.3065C5.1369 19.6358 5.46306 19.9441 5.80755 20.2292" stroke="#070925" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
</svg> <strong>Duration:</strong> {program?.ProgramDuration || '-'}</p>
            </div>

            <div className="space-y-2">
              <p className="flex items-center gap-2">
                <strong>Enabled:</strong>{' '}
                <YesNoRendererComponent value={program?.IsEnabled} />
              </p>
              <p className="flex items-center gap-2">
                 <strong>Includes Activities:</strong>{' '}
                <YesNoRendererComponent value={program?.IncludesActivities} />
              </p>
            </div>
          </div>

          <div className="mb-6">
            <h3 className="text-xl font-semibold text-indigo-800 mb-2">Program Description</h3>
            <p className="text-gray-800 bg-white p-4 rounded-md shadow-sm">
              {program?.Description || ''}
            </p>
          </div>
{(Array.isArray(program?.Specifications) && program.Specifications.length > 0) ||
 (Array.isArray(program?.Activities) && program.Activities.length > 0) ? (
  <div className="flex flex-wrap gap-4 mb-6">
    
  
    {Array.isArray(program?.Specifications) && program.Specifications.length > 0 && (
      <div className="flex-1 min-w-[300px]">
        <h3 className="text-xl font-semibold text-orange-700 mb-2">What’s Included</h3>
        <div className="flex flex-wrap gap-2">
          {program.Specifications.map((spec: string, index: number) => (
            <span
              key={index}
              className="bg-white border border-orange-300 text-orange-700 px-3 py-1 rounded-full text-sm font-medium shadow-sm hover:bg-orange-100"
            >
              {spec}
            </span>
          ))}
        </div>
      </div>
    )}


    {Array.isArray(program?.Activities) && program.Activities.length > 0 && (
      <div className="flex-1 min-w-[300px]">
        <h3 className="text-xl font-semibold text-rose-700 mb-2">Activities</h3>
        <div className="flex flex-wrap gap-2">
          {program.Activities.map((activity: string, index: number) => (
            <span
              key={index}
              className="bg-white border border-pink-300 text-rose-700 px-3 py-1 rounded-full text-sm font-medium shadow-sm hover:bg-pink-100"
            >
              {activity}
            </span>
          ))}
        </div>
      </div>
    )}

  </div>
) : null}

        </div>
      }
    />
  );
}
